import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderPaymentDto
*  Информация об оплате<br>
*/
export class OrderPaymentDto extends ActiveModel {

/**
  * paymentUrl
  * Ссылка на оплату; null при отложенной оплате — платёж на витрине не проводится.
  */
  @ActiveField(null)
  paymentUrl: null | string = null


/**
  * validTill
  * Оплата возможна до указанного времени<br>
  */
  @ActiveField(null)
  validTill: null | string = null


/**
  * methodCode
  * Код выбранного способа оплаты (из реестра методов шлюза).<br>
  */
  @ActiveField('')
  methodCode: string = ''
}
